module.exports = __webpack_public_path__ + "static/img/kv.2233d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/recruit_2024/galaxy_award/kv.png
// module id = xmZq
// module chunks = 0